import {
  sendEmail,
  sendEmailVariables,
  type sendPaymentFailed,
  type sendPaymentFailedVariables,
} from "#types/code-generator.ts";
import type { TypedDocumentNode } from "#types/graphql.d.ts";
import { gql } from "graphql-tag";

export const SendEmailMutation = gql`
  mutation sendEmail($data: SendEmailInput!) {
    sendEmail(data: $data) {
      success
    }
  }
` as TypedDocumentNode<sendEmail, sendEmailVariables>;

export const SendPaymentFailedMutation = gql`
  mutation sendPaymentFailed($userIds: [ID!]!) {
    sendPaymentFailed(userIds: $userIds) {
      success
    }
  }
` as TypedDocumentNode<sendPaymentFailed, sendPaymentFailedVariables>;
